export default __webpack_public_path__ + "static/media/photo7.c4a39e4a.jpg";